import { useContext, useEffect, useRef, useMemo, HTMLAttributes } from 'react';
import { Collapse } from 'react-collapse';
import AccordionPanelContext from '../AccordionPanel/AccordionPanelContext';
import useStyles from './AccordionPanelContent.styles';
import registerDefaults from '../themeDefaults';

registerDefaults();

const AccordionPanelContentComponent = ({
  children,
  className,
}: HTMLAttributes<HTMLDivElement>) => {
  const { isOpen, panelId } = useContext(AccordionPanelContext);
  const classes = useStyles();
  const isOpenPrevious = useRef(isOpen);

  useEffect(() => {
    isOpenPrevious.current = isOpen;
  }, [isOpen]);

  /**
   * childrenMemo will be set as null only on initial render if isOpened is set to false. Subsequent
   * renders will already have the child rendered.
   */
  const childrenMemo = useMemo(() => {
    if (!isOpen && !isOpenPrevious.current) {
      return null;
    }
    if (typeof children === 'string') {
      return <span>{children}</span>;
    }
    return children;
  }, [children, isOpen]);

  return (
    <Collapse isOpened={!!isOpen}>
      {childrenMemo && (
        <article
          aria-labelledby={panelId}
          className={`${classes.accordionContent} ${className}`}
          role="region"
        >
          {childrenMemo}
        </article>
      )}
    </Collapse>
  );
};

AccordionPanelContentComponent.displayName = 'AccordionPanelContent';

export default AccordionPanelContentComponent;
